/**
 * So we do this validation since eActive does only the back-end validation
 * This validation is very primitive, but the idea behind this was to just remove the back-end input-errors if there are any
 * We took the opportunity to add a valid css class on the inputs as well
 *
 * MVP - To do: keep feedback CSS classes on submit and perhaps ask eActive for back-end validation rules to keep FE and BE consistent
 */

const ShopFormValidation = (function(window, $) {
    function ShopFormValidation() {

        this.givenname = $('form[name="order"] #order_invoiceAddress_initials');
        this.familyname = $('form[name="order"] #order_invoiceAddress_lastName');
        this.email = $('form[name="order"] #order_email');
        this.postalcode = $('form[name="order"] #order_invoiceAddress_zipcode');
        this.addressline2 = $('form[name="order"] #order_invoiceAddress_houseNumber');
        this.adressprefilled = $('form[name="order"] .adress-prefilled');
        this.checkboxalgv = $('form[name="order"] #order_conditions');

        this.addEvents();
    }

    ShopFormValidation.prototype.addEvents = function() {
        this.givenname.on('blur', this.checkExistenceTextValue.bind(this));
        this.familyname.on('blur', this.checkExistenceTextValue.bind(this));
        this.email.on('blur', this.checkEmailValues.bind(this));
        this.postalcode.on('blur', this.checkZipcodeValues.bind(this));
        this.postalcode.on('blur', this.checkVisibilityPrefillAdress.bind(this));
        this.addressline2.on('blur', this.checkExistenceTextValue.bind(this));
        this.addressline2.on('blur', this.checkVisibilityPrefillAdress.bind(this));
        this.checkboxalgv.on('click', this.checkCheckedBox.bind(this));
    };

    /* Set up a generic error check on existence which is generated by third party eActive's backend when submiting the form */
    ShopFormValidation.prototype.checkBackEndInputError = function(target) {
        let inputerror = $(target).next('.input-error'); // find the apropriate input error

        if(inputerror.length) { // check if there's a back-end validation error in the dom at the input field
            inputerror.remove(); // and remove the error since we have validated this on our front-end - it will come back at the back-end validation by third party e-Actove
        }
    }

    /* Set up a generic existence check if there's a value of any kind */
    ShopFormValidation.prototype.checkExistenceTextValue = function(e) {
        let target = $(e.target)[0];

        if(target.value.length > 0) {
            target.classList.add('is-fe-validated');
            this.checkBackEndInputError(target);
        } else {
            target.classList.remove('is-fe-validated');
        }
    }

    /*
     * Check existence of text and minimum an @ and a . - not really complicated, it's more less for letting the browser know
     * that the backend validation error can be removed. But feel free to add more value checks
    */
    ShopFormValidation.prototype.checkEmailValues = function(e) {
        let target = $(e.target)[0];
        let email = target.value;
        let emailLength = email.length;
        let emailRegex = /^\S+@\S+\.\S+$/;

        if(emailLength >= 5 && emailRegex.test(email)) {
            target.classList.add('is-fe-validated');
            this.checkBackEndInputError(target);
        } else {
            target.classList.remove('is-fe-validated');
        }
    }

    /*
     * Check existence of min. 4 numbers in Zipcode field and two letters ) -
     * real validation occurs on third party e-Actives back-end side
     */
    ShopFormValidation.prototype.checkZipcodeValues = function(e) {
        let target = $(e.target)[0];
        let zipcode = target.value;
        let zipcodeLength = zipcode.length;
        let zipcodeRegex = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;

        if(zipcodeLength >= 1) {
            if(zipcodeRegex.test(zipcode)) {
                target.classList.add('is-fe-validated');
                this.checkBackEndInputError(target);
            } else {
                target.classList.remove('is-fe-validated');
            }
        }
    }

    /* Check visibilty of adressprefilled block - if there then the inputerror must be removed since the adress exists (this is already checked by eActive) */
    ShopFormValidation.prototype.checkVisibilityPrefillAdress = function() {
        if(this.adressprefilled.is(":visible")) {
            this.adressprefilled.next('.input-error').remove();
        }
    }

    /* Check checked state of the AV - when checked remove the input error */
    ShopFormValidation.prototype.checkCheckedBox = function() {
        if(this.checkboxalgv.is(":checked")) {
            this.checkboxalgv.closest('.form-group').find('.input-error').remove();
        }
    }

    return ShopFormValidation;

}(window, jQuery));

export {ShopFormValidation};
